import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WArticleBodyNewsCCD: IClientComponentDefinition = {
  name: 'WArticleBodyNews',
  load: () => import(/* webpackChunkName: 'WArticleBodyNews' */ './w-article-body-news.components'),
}
